/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportButton_comment = {
    readonly id: string;
    readonly author: {
        readonly username: string | null;
    } | null;
    readonly viewerActionPresence: {
        readonly dontAgree: boolean;
        readonly flag: boolean;
    } | null;
    readonly " $refType": "ReportButton_comment";
};
export type ReportButton_comment$data = ReportButton_comment;
export type ReportButton_comment$key = {
    readonly " $data"?: ReportButton_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportButton_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportButton_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ActionPresence",
            "kind": "LinkedField",
            "name": "viewerActionPresence",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dontAgree",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flag",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '04d90cecac4d79ca6815c9dfcf91c70b';
export default node;
